module.exports = __webpack_public_path__ + "img/logo_ongeo_by_dark.ce7f1281.svg";